export default __webpack_public_path__ + "static/media/mamut_l3.234806a2.png";